<script>
  export default {
    props: {
      breadcrumbs: {
        type: Array,
        required: true
      }
    }
  }
</script>

<template>
  <div class="bread-crumbs border-b border-gray-200 md:border-0">
    <div class="container px-4 md:px-8 flex items-center">
      <div class="hidden md:flex items-center">
        <div class="go-back-button">
          <slot></slot>
        </div>
        <div class="divider"></div>
      </div>
      <ul class="flex flex-wrap py-2">
        <li>
          <nuxt-link
            to="/"
            class="text-gray-500 hover:text-gray-600 default-transition text-sm"
          >
            home
          </nuxt-link>
        </li>
        <li
          v-for="crumb in breadcrumbs"
          :key="crumb.title"
        >
          <nuxt-link
            v-if="crumb.slug"
            :to="crumb.slug"
            class="text-gray-500 hover:text-gray-600 default-transition text-sm"
          >
            {{ crumb.title }}
          </nuxt-link>
          <span
            v-else
            class="text-gray-500 text-sm"
          >
            {{ crumb.title }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
.go-back-button {
  .button-tertiary {
    @apply text-blue-500;
    .q-icon {
      transform: rotate(180deg);
    }
  }
}

.divider {
  height: 1.3125rem;
  width: 1px;
  @apply bg-gray-200;
  @apply mx-4;
}

.bread-crumbs {

  ul {

    li:not(:last-child) {
      &:after {
        content: '/';
        @apply text-gray-500 text-sm px-2;
      }
    }

    .nuxt-link-exact-active {
      @apply text-gray-600;
    }

  }

}

</style>
